import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicREtoFA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Regular Expression to Finite Automata"
      videos={[
        "https://www.youtube.com/embed/nlbmmgDw8Dg", // Thomson's Method
        "https://www.youtube.com/embed/sUcuOUXkKR0", // Direct Method
      ]}
      takeaways={[
        { text: "Practice at least one question in each subtopic." },
        { text: "Don’t get confused with the method names." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicREtoFA };
